import { deleteFormTemplate } from "../graphql/mutations";
import { generateClient } from "aws-amplify/api";
import { recordSentry } from "utils/recordSentry";

export async function handleDeleteFormTemplate(id: string): Promise<boolean> {
	try {
		const input = { id };
		const client = generateClient({ authMode: "userPool" });
		await client.graphql({
			query: deleteFormTemplate,
			variables: {
				input,
			},
			authMode: "userPool",
		});
		return true;
	} catch (error: any) {
		recordSentry({ error });
	}
	return false;
}
